import type { RouteRecordRaw } from 'vue-router'

function Layout() {
  return import('@/layouts/index.vue')
}

const routes: RouteRecordRaw = {
  path: '/help-category',
  component: Layout,
  name: 'HelpCategoryManagement',
  meta: { title: '帮助类别', icon: 'i-ep:folder', menu: false },
  children: [
    {
      path: 'list',
      name: 'HelpCategoryList',
      component: () => import('@/views/help/category/index.vue'),
      meta: { title: '帮助类别', icon: 'i-ep:folder' },
    },
    {
      path: 'create',
      name: 'HelpCategoryCreate',
      component: () => import('@/views/help/category/form.vue'),
      meta: { title: '创建类别', icon: 'i-ep:plus', menu: false, activeMenu: '/help-category/list' },
    },
    {
      path: 'edit/:id',
      name: 'HelpCategoryEdit',
      component: () => import('@/views/help/category/form.vue'),
      meta: { title: '编辑类别', icon: 'i-ep:edit', menu: false, activeMenu: '/help-category/list' },
    },
  ],
}

export default routes
